"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HexColorInput = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../utils");
var Form_1 = require("../../Form");
var HexColorInput = /** @class */ (function (_super) {
    tslib_1.__extends(HexColorInput, _super);
    function HexColorInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onInputChange = function (value) {
            if (utils_1.isHexColorValid(value)) {
                var newHsl = utils_1.getHslFromHexColor(value);
                _this.props.onInputChanged(newHsl);
            }
        };
        return _this;
    }
    HexColorInput.prototype.render = function () {
        var hexValue = utils_1.getHexFromHslColor(this.props.initColor);
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(Form_1.Input, { className: "s-color-picker-hex", value: hexValue, onChange: this.onInputChange, placeholder: this.props.placeholder }),
            react_1.default.createElement("p", null, this.props.label)));
    };
    HexColorInput.defaultProps = {
        placeholder: "",
        label: "",
    };
    return HexColorInput;
}(react_1.PureComponent));
exports.HexColorInput = HexColorInput;
//# sourceMappingURL=HexColorInput.js.map